import type {CSSProperties} from 'react'

type CellStyleProps = Pick<CSSProperties, 'height'> & {width: number}

/**
 * Provides the styles for a block layout cell.
 * Based on TanStack Table v7 API:
 * - docs: https://react-table-v7-docs.netlify.app/docs/api/useblocklayout
 * - source: https://github.com/TanStack/table/blob/v7/src/plugin-hooks/useBlockLayout.js
 */
export const getCellStyles = ({height, width}: CellStyleProps): CSSProperties => ({
  display: 'inline-block',
  boxSizing: 'border-box',
  height,
  width,
})

type ColSpan = {colSpan: number}
type HeaderCellProps = CellStyleProps & ColSpan
type HeaderCellPropsReturnType = {style: CSSProperties} & ColSpan

/**
 * Provides the styles and properties for a resizable header cell.
 * Based on TanStack Table v7 APIs:
 * - docs: https://react-table-v7-docs.netlify.app/docs/api/useResizeColumns
 * - source: https://github.com/TanStack/table/blob/v7/src/plugin-hooks/useResizeColumns.js
 * - source: https://github.com/TanStack/table/blob/v7/src/makeDefaultPluginHooks.js
 */
export const getHeaderCellProps = (props: HeaderCellProps): HeaderCellPropsReturnType => ({
  style: {
    ...getCellStyles(props),
    position: 'relative',
  },
  colSpan: props.colSpan,
})
